exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simple-table-container td{font-weight:400!important;font-size:13px!important}", ""]);

// exports
